export enum ExportPlanSuccessEvent {
  MASTER_PLAN_PLAN_SET = "config:exported_masterplan_plan_set",
  COMMUNITY_PLAN_PLAN_SET = "config:exported_communityplan_plan_set",
  LOT_PLAN_SET = "config:exported_lot_plan_set",
  STUDIO_DOC_PLAN_SET = "config:exported_studiodoc_plan_set",
  HOME_PLAN_SALES_BROCHURE = "config:exported_homeplan_sales_brochure",
  HOME_PLAN_PLAN_SET = "config:exported_homeplan_plan_set",
}

const FAILURE_EVENT_SUFFIX = "_failed";

export type FailureEvent<T extends string> = `${T}${typeof FAILURE_EVENT_SUFFIX}`;

export function exportPlanFailureEvent<T extends string>(eventName: T): FailureEvent<T> {
  return `${eventName}${FAILURE_EVENT_SUFFIX}`;
}

export function isExportPlanFailureEvent(eventName: string): boolean {
  return eventName.endsWith(FAILURE_EVENT_SUFFIX);
}

export type ExportPlanFailureEvent = FailureEvent<ExportPlanSuccessEvent>;

export type ExportPlanEvent = ExportPlanSuccessEvent | ExportPlanFailureEvent;
